import { TRIGGER_CONNECTION_NAME } from "./_Base";
import { NodeParamsConfig, ParamConfig } from "../utils/params/ParamsConfig";
import {
  ActorConnectionPoint,
  ActorConnectionPointType,
  ACTOR_CONNECTION_POINT_IN_NODE_DEF
} from "../utils/io/connections/Actor";
import { ActorType } from "../../poly/registers/nodes/types/Actor";
import { BaseUserInputActorNode } from "./_BaseUserInput";
import { isBooleanTrue } from "../../../core/Type";
const CONNECTION_OPTIONS = ACTOR_CONNECTION_POINT_IN_NODE_DEF;
class OnObjectHoverActorParamsConfig extends NodeParamsConfig {
  constructor() {
    super(...arguments);
    this.traverseChildren = ParamConfig.BOOLEAN(1);
    this.pointsThreshold = ParamConfig.FLOAT(0.1);
    this.lineThreshold = ParamConfig.FLOAT(0.1);
  }
}
const ParamsConfig = new OnObjectHoverActorParamsConfig();
export class OnObjectHoverActorNode extends BaseUserInputActorNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
    this._intersections = [];
    this._lastIntersectionStateByObject = /* @__PURE__ */ new Map();
  }
  static type() {
    return ActorType.ON_OBJECT_HOVER;
  }
  userInputEventNames() {
    return ["pointermove"];
  }
  initializeNode() {
    super.initializeNode();
    this.io.outputs.setNamedOutputConnectionPoints([
      new ActorConnectionPoint(TRIGGER_CONNECTION_NAME, ActorConnectionPointType.TRIGGER, CONNECTION_OPTIONS),
      new ActorConnectionPoint("hovered", ActorConnectionPointType.BOOLEAN, CONNECTION_OPTIONS)
    ]);
    this.io.connection_points.spare_params.setInputlessParamNames(["pointsThreshold", "lineThreshold"]);
  }
  receiveTrigger(context) {
    const { Object3D: Object3D2 } = context;
    const pointerEventsController = this.scene().eventsDispatcher.pointerEventsController;
    const raycaster = pointerEventsController.raycaster();
    pointerEventsController.updateRaycast(this.pv);
    this._intersections.length = 0;
    const intersections = raycaster.intersectObject(Object3D2, isBooleanTrue(this.pv.traverseChildren), this._intersections);
    const newHoveredState = intersections[0] != null;
    const previousHoveredState = this._lastIntersectionStateByObject.get(Object3D2);
    const hoveredStateChanged = previousHoveredState == null || newHoveredState != previousHoveredState;
    if (hoveredStateChanged) {
      this._lastIntersectionStateByObject.set(Object3D2, newHoveredState);
      this.runTrigger(context);
    }
  }
  outputValue(context) {
    const { Object3D: Object3D2 } = context;
    return this._lastIntersectionStateByObject.get(Object3D2);
  }
}
